export default function Dresscode({ copy }) {
  return (
    <section id="dresscode" className="dresscode section-shell">
      <div className="dresscode-inner">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
        <p>{copy.copy}</p>
      </div>
    </section>
  );
}